var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import PenManager from '../../neosmartpen/PenManager';
import { PU_TO_NU } from '../constants';
import { IBrushType, PEN_THICKNESS } from '../enums/PenEnums';
import { makeNPageIdStr } from '../util';
/// <reference path="../nl-lib/@types/NPROJ.d.ts"
import GridaPuiNproj from "./nproj/3_1013_1116_Grida.nproj";
import GenericPuiNproj from "./nproj/note_3_1013_1.nproj";
import PaperTubePuiNproj from "./nproj/papertube_controller_171117.nproj";
import SmartClassKitPuiProj from "./nproj/SmartClassKit_Controller.nproj";
const predefinedPuiGroup = [GridaPuiNproj, GenericPuiNproj, PaperTubePuiNproj, SmartClassKitPuiProj];
// const a = GridaController;
// // fetch(a).then(async res => {
// //   const b = await res.text();
// //   console.log(b);
// // })
// // console.log(a, a.length);
let _puiInstance = null;
function insidePolygon(point, vs) {
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
    const { x, y } = point;
    let inside = false;
    for (let i = 0, j = vs.length - 1, l = vs.length; i < l; j = i++) {
        const { x: xi, y: yi } = vs[i];
        const { x: xj, y: yj } = vs[j];
        // let xi = vs[i][0], yi = vs[i][1];
        // let xj = vs[j][0], yj = vs[j][1];
        const intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect)
            inside = !inside;
    }
    return inside;
}
function insideRectangle(point, rc) {
    return (point.x >= rc.left) && (point.x <= rc.left + rc.width) &&
        (point.y >= rc.top) && (point.y <= rc.top + rc.height);
}
function insideEllipse(point, el) {
    const p = Math.pow((point.x - el.x), 2) / Math.pow(el.width, 2) + Math.pow((point.y - el.y), 2) / Math.pow(el.height, 2);
    return p <= 1;
}
export default class PUIController {
    constructor() {
        this._pageSymbols = {};
        this.readPredefinedSymbols = () => __awaiter(this, void 0, void 0, function* () {
            // TODO: 하드 코딩된 PUI만 읽어오는데, 중앙 서버에서 PUI가 추가되면 update하고, 그것을 여기서 읽을 수 있도록 해야 한다.
            for (const url of predefinedPuiGroup) {
                // nproj 파일에서 symbol을 받는다.
                const symbols = yield this.getPuiXML(url);
                // 해당 페이지에 symbol을 넣고,
                for (const s of symbols) {
                    const idStr = makeNPageIdStr(s.sobp);
                    if (!this._pageSymbols[idStr])
                        this._pageSymbols[idStr] = [];
                    this._pageSymbols[idStr].push(s);
                    // if (!commands.includes(s.command)) commands.push(s.command);
                }
            }
            // 아래는 어떤 symbol이 있는지 점검하기 위해
            // const commands = [] as string[];
            // Object.entries(this._pageSymbols).forEach(([sobpStr, symbols]) => {
            //   symbols.forEach(s => {
            //     if (!commands.includes(s.command)) commands.push(s.command);
            //   })
            // });
            // commands.sort((a, b) => a > b ? 1 : -1);
            // console.log(commands);
        });
        this.getStrokePuiCommand = (stroke) => __awaiter(this, void 0, void 0, function* () {
            yield this._ready;
            const dots = stroke.dotArray;
            const commands = [];
            for (const dot of stroke.dotArray) {
                const command = this.getPuiCommand_sync(stroke, dot);
                if (command) {
                    if (!commands.includes(command))
                        commands.push(command);
                }
            }
            return commands;
        });
        this.getPuiCommand_sync = (sobp, point_nu) => {
            const pageSymbols = this._pageSymbols[makeNPageIdStr(sobp)];
            if (!pageSymbols)
                return undefined;
            for (const s of pageSymbols) {
                switch (s.type) {
                    case "Rectangle": {
                        if (insideRectangle(point_nu, s.rect_nu))
                            return s.command;
                        break;
                    }
                    case "Ellipse": {
                        if (insideEllipse(point_nu, s.ellipse_nu))
                            return s.command;
                        break;
                    }
                    case "Polygon": {
                        if (insidePolygon(point_nu, s.polygon)) {
                            return s.command;
                        }
                        break;
                    }
                }
            }
            return undefined;
        };
        this.getPageSizeNu = (nprojXml) => {
            const $pages = $(nprojXml).find("pages");
            const $page_items = $pages.find("page_item");
            const ret = Array.from({ length: $page_items.length });
            $page_items.each((index, page) => {
                const p = $(page);
                const pageDelta = parseInt(p.attr("number"));
                const surface_pu = {
                    left: parseFloat(p.attr("x1")),
                    top: parseFloat(p.attr("y1")),
                    right: parseFloat(p.attr("x2")),
                    bottom: parseFloat(p.attr("y2")),
                };
                const $crop_margin = p.attr("crop_margin");
                const margins = $crop_margin.split(",");
                const padding_pu = {
                    left: parseFloat(margins[0]),
                    top: parseFloat(margins[1]),
                    right: parseFloat(margins[2]),
                    bottom: parseFloat(margins[3]),
                };
                const size_pu = {
                    width: (surface_pu.right - padding_pu.right) - (surface_pu.left + padding_pu.left),
                    height: (surface_pu.bottom - padding_pu.bottom) - (surface_pu.top + padding_pu.top),
                };
                const nu = {
                    Xmin: (surface_pu.left + padding_pu.left) * PU_TO_NU,
                    Ymin: (surface_pu.top + padding_pu.top) * PU_TO_NU,
                    Xmax: (surface_pu.left + size_pu.width) * PU_TO_NU,
                    Ymax: (surface_pu.top + size_pu.height) * PU_TO_NU,
                };
                // const Xmax_physical = (surface_pu.right - padding_pu.right) * PU_TO_NU;
                // const Ymax_physical = (surface_pu.bottom - padding_pu.bottom) * PU_TO_NU;
                // 결과를 push
                const item = {
                    padding_pu, size_pu, nu
                };
                ret[pageDelta] = item;
            });
            return ret;
        };
        this.getPuiXML = (url) => __awaiter(this, void 0, void 0, function* () {
            const symbols = [];
            const res = yield fetch(url);
            const nprojXml = yield res.text();
            // console.log(nprojXml);
            // book 정보
            const $bookXml = $(nprojXml).find("book");
            const section = parseInt($bookXml.find("section").text());
            const owner = parseInt($bookXml.find("owner").text());
            const book = parseInt($bookXml.find("code").text());
            const startPage = parseInt($bookXml.find("start_page").text());
            // page 정보
            const $pagesXml = $(nprojXml).find("pages");
            const numPages = parseInt($pagesXml.attr("count"));
            const pages = this.getPageSizeNu(nprojXml);
            // symbol 정보
            const $symbols = $(nprojXml).find("symbols");
            const symbolXml = $symbols.find("symbol");
            const listLength = symbolXml.length;
            $(symbolXml).each(function (index, sym) {
                // console.log(sym.outerHTML);
                const pageDelta = parseInt($(sym).attr("page"));
                const type = $(sym).attr("type"); // 여기서는 Rectangle만 취급한다.
                const x = parseFloat($(sym).attr("x"));
                const y = parseFloat($(sym).attr("y"));
                const width = parseFloat($(sym).attr("width"));
                const height = parseFloat($(sym).attr("height"));
                const command = $(sym).find("command").attr("param");
                const page = pageDelta + startPage;
                const sobp = { section, owner, book, page };
                switch (type) {
                    case "Rectangle": {
                        const puiSymbol = {
                            type,
                            command,
                            sobp,
                            rect_nu: {
                                left: x * PU_TO_NU,
                                top: y * PU_TO_NU,
                                width: width * PU_TO_NU,
                                height: height * PU_TO_NU,
                            },
                        };
                        symbols.push(puiSymbol);
                        break;
                    }
                    case "Ellipse": {
                        const puiSymbol = {
                            type,
                            command,
                            sobp,
                            ellipse_nu: {
                                x: x * PU_TO_NU,
                                y: y * PU_TO_NU,
                                width: width * PU_TO_NU,
                                height: height * PU_TO_NU,
                            },
                        };
                        symbols.push(puiSymbol);
                        break;
                    }
                    default: {
                        throw new Error(`symbol type(${type} is not "Rectangle" nor "Ellipse"`);
                    }
                }
            });
            return symbols;
        });
        this._ready = this.readPredefinedSymbols();
    }
    static getInstance() {
        if (!_puiInstance) {
            _puiInstance = new PUIController();
        }
        return _puiInstance;
    }
    // constructor(url) {
    //   /** @type {Promise} */
    //   this._ready = this.getPuiXML(url);
    //   /** @type {number} */
    //   this._owner = 0;
    //   /** @type {number} */
    //   this._section = 0;
    //   /** @type {number} */
    //   this._book = 0;
    //   /** @type {number} */
    //   this._startPage = 0;
    //   /** @type {Array.<number>} */
    //   this._pages = [];
    //   /** @type {Array.<{pageDelta:number, type:string, left:number, top:number, width:number, height:number, command:string}>} */
    //   this._symbols = [];
    // }
    get ready() {
        return this._ready;
    }
    m(val) {
        return Math.round(val * 10) / 10;
    }
    // getCommand(owner, book, page, x, y) {
    //   if (owner != this._owner || book != this._book) return null;
    //   const pageDelta = page - this._startPage;
    //   if (this._pages.findIndex((elem) => elem == page) < 0) return null;
    //   let i;
    //   for (i = 0; i < this._symbols.length; i++) {
    //     const sym = this._symbols[i];
    //     const x1 = sym.left / 72; // inch
    //     const x2 = (sym.left + sym.width) / 72; // inch
    //     const y1 = sym.top / 72;
    //     const y2 = (sym.top + sym.height) / 72;
    //     const xx = (x * 56) / 600;
    //     const yy = (y * 56) / 600;
    //     if (sym.pageDelta == pageDelta) {
    //       if (x1 < xx && xx < x2 && y1 < yy && yy < y2) {
    //         const m = this.m;
    //         console.log(`(${m(xx)}, ${m(yy)}) in (${m(x1)}, ${m(y1)})-(${m(x2)}, ${m(y2)}) ==> ${sym.command}`);
    //         return sym.command;
    //       }
    //     }
    //   }
    //   return null;
    // }
    /**
     *
     * @param {string} cmd
     */
    static executeCommand(cmd) {
        // const page_num = $('#page_input').val() - 1
        switch (cmd) {
            case "strokesize_1":
            case "0.1": //lamy
                PenManager.getInstance().setThickness(PEN_THICKNESS.THICKNESS1);
                break;
            case "strokesize_2":
            case "0.5": //lamy
                PenManager.getInstance().setThickness(PEN_THICKNESS.THICKNESS3);
                break;
            case "strokesize_3":
            case "1.7": //lamy
                PenManager.getInstance().setThickness(PEN_THICKNESS.THICKNESS5);
                break;
            case "pen":
                PenManager.getInstance().setPenRendererType(IBrushType.PEN);
                break;
            case "highlighter":
                PenManager.getInstance().setPenRendererType(IBrushType.MARKER);
                break;
            case "erase_brush":
                PenManager.getInstance().setPenRendererType(IBrushType.ERASER);
                break;
            case "#FFE5E5E5": //LG
            case "white":
                PenManager.getInstance().setColor(1);
                break;
            case "#FF000000": //BK
            case "black":
                PenManager.getInstance().setColor(3);
                break;
            case "#FFAAAAAA": // DG
            case "#AAAAAA": //lamy
                PenManager.getInstance().setColor(2);
                break;
            case "#FFFFD001": // YE
            case "yellow":
                PenManager.getInstance().setColor(8);
                break;
            case "#FFFF6500": // OR
                PenManager.getInstance().setColor(9);
                break;
            case "#FFFF0200": // RED
            case "red":
                PenManager.getInstance().setColor(0);
                break;
            case "#FF00ABEB": // BLU
            case "lightblue":
                PenManager.getInstance().setColor(6);
                break;
            case "#FF3CDD00": // GRN
            case "green":
                PenManager.getInstance().setColor(7);
                break;
            case "#FF6C00E2": // PPL
                PenManager.getInstance().setColor(4);
                break;
            case "#FF012EE2": // NAVY
                PenManager.getInstance().setColor(5);
                break;
            // TODO: 아래의 커멘드들 처리할 것
            // case "pointer": {
            //   const isTrace = store.getState().pointerTracer.isTrace;
            //   store.dispatch(setPointerTracer(!isTrace));
            //   const $elem = $(`#${"btn_tracepoint"}`);
            //   if (!isTrace) {
            //     const $elem = $("#btn_tracepoint").find(".c2");
            //     $elem.addClass("checked");
            //     $('#btn_tracepoint').css('background', 'white');
            //     $('#tracer_svg_icon').css('color', '#688FFF');
            //   } else {
            //     const $elem = $("#btn_tracepoint").find(".c2");
            //     $elem.removeClass("checked");
            //     $('#btn_tracepoint').css('background', 'none');
            //     $('#tracer_svg_icon').css('color', '#58627D');
            //   }
            //   break;
            // }
            // case "erase_all": {
            //   const activePageNo = store.getState().activePage.activePageNo;
            //   const doc = GridaDoc.getInstance();
            //   const pageInfo = doc.getPage(activePageNo).pageInfos[0];
            //   const inkStorage = InkStorage.getInstance();
            //   inkStorage.dispatcher.dispatch(PageEventName.PAGE_CLEAR, pageInfo);
            //   inkStorage.removeStrokeFromPage(pageInfo);
            //   break;
            // }
            // case "menu_grida":
            //   break;
            // case "fit":
            //   setViewFit(ZoomFitEnum.WIDTH);
            //   break;
            // case "full":
            //   setViewFit(ZoomFitEnum.HEIGHT);
            //   break;
            // case "full_screen":
            //   setViewFit(ZoomFitEnum.WIDTH);
            //   break;
            // case "zoom_in": {
            //   setViewFit(ZoomFitEnum.FREE);
            //   const zoom = store.getState().zoomReducer.zoom;
            //   const delta = -100;
            //   const newZoom = zoom * 0.9985 ** delta
            //   setZoomStore(newZoom);
            //   break;
            // }
            // case "zoom_out": {
            //   setViewFit(ZoomFitEnum.FREE);
            //   const zoom = store.getState().zoomReducer.zoom;
            //   const delta = 100;
            //   const newZoom = zoom * 0.9985 ** delta
            //   setZoomStore(newZoom);
            //   break;
            // }
            // case "previous": {
            //   const activePageNo = store.getState().activePage.activePageNo
            //   if (activePageNo === 0) {
            //     return;
            //   }
            //   setActivePageNo(activePageNo-1);
            //   break;
            // }
            // case "next": {
            //   const activePageNo = store.getState().activePage.activePageNo;
            //   const numDocPages = store.getState().activePage.numDocPages;
            //   if (activePageNo === numDocPages-1) {
            //     return;
            //   }
            //   setActivePageNo(activePageNo+1);
            //   break;
            // }
        }
    }
}
//# sourceMappingURL=PUIController.js.map